<template>
  <DxPopup
    :visible.sync="getVisible"
    :drag-enabled="false"
    :hide-on-outside-click="true"
    :show-title="true"
    :title="'Send Statement'"
    :width="'50%'"
    :height="295"
    :showCloseButton="false"
    @hidden="popupHidden"
    :fullScreen="false"
    ref="gc-popup"
    :wrapperAttr="{ class: 'css-v2 gc-popup' }"
  >
    <div class="css-v2 gc-popup-form">
      <gc-form
        :formOptions="{
          gcLabelLocation: 'left',
        }"
        :formItems="getFormItems"
        :formHeight="175"
        :isNormal="true"
        :data-model="dataModel"
        :formMode="'create'"
        :validationGroup="'gcPopupConfig-gc-popup-form-data'"
        :formTitle="'gc-popup'"
        v-if="getFormItems"
        :valueChangeCallBack="valueChangeCallBack"
        :checkValid="IsValid"
      ></gc-form>
    </div>

    <div class="footer" v-bind:class="'multi-btn gc-data-grid'">
      <DxButton
        :text="'Preview'"
        type="success"
        styling-mode="contained"
        @click="onPreview"
      />
      <DxButton
        :text="'Email'"
        type="success"
        styling-mode="contained"
        @click="onEmail"
      />
      <DxButton
        :text="'Cancel'"
        type="default"
        styling-mode="contained"
        @click="onCancel"
      />
    </div>
  </DxPopup>
</template>

<script>
import validationEngine from "devextreme/ui/validation_engine";
import ApiService from "../../_services/api/api.service";
import { CustomerStatementService } from "../../_services/api/customers/customer-statement.service";
import { TransactionReportService } from "../../_services/api/reports/transaction-report.service";
import { UserService } from "../../_services/api/settings/user/user.service";
import { getFactorByCode, getGlobalField } from "../../_store/helpers";
import SettingsService from "../../_services/api/settings/graycorp/settings.service";
import { IsResponseDataValid } from "../../_helpers/ui/helpers";

const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};
export default {
  props: {
    setVisible: Boolean,
    almondcoDespatchData: {
      type: Object,
      default: () => {},
    },
    showLoading: {
      type: Function,
      default: function () {},
    },
    showValidationSummary: {
      type: Function,
      default: function () {},
    },
    hidden: {
      type: Function,
      default: () => {},
    },
    dataObj: {
      type: Object,
      default: () => {},
    },
    displayValidationSummary: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      dataModel: {
        StatementType: undefined,
        StartDate: new Date(),
        EndDate: new Date(),
        CustomerCode: undefined,
        Agedby: "Month",
        CustomerName: undefined,
      },
      IsValid: false,
      report: undefined,
    };
  },
  async created() {
    // Get the default aging method from setting and set to aged by option
    let CustomerStatementMethod = await SettingsService.getBySettingName(
      "CustomerStatementMethod",
    );

    // If the setting is not found or invalid, default to "Month"
    if (IsResponseDataValid(CustomerStatementMethod)) {
      const method = CustomerStatementMethod.data.value[0].SettingValue;
      if (method) this.dataModel.Agedby = method;
    }

    if (this.dataObj.Code) this.dataModel.CustomerCode = this.dataObj.Code;
    if (this.dataObj.Name) this.dataModel.CustomerName = this.dataObj.Name;
    await this.$store.dispatch(
      "screenFactors/getFactors",
      [660], // , 65, 66]
    );
    this.dataModel.StatementType = getFactorByCode(660).Factorc;
  },
  computed: {
    // getVisible() {
    //   return this.setVisible ? true : false;
    // },
    getFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "StatementType",
                  editorType: "dxSelectBox",
                  editorOptions: {
                    items: [
                      {
                        value: "Activity",
                      },
                      {
                        value: "Outstanding",
                      },
                    ],
                    valueExpr: "value",
                    displayExpr: "value",
                    showClearButton: true,
                    allowUpdate: true,
                    onValueChanged: (e) => {
                      this.onStatementTypeChanged(e);
                    },
                  },
                  required: true,
                },
                {
                  screenField: "Date",
                  label: {
                    text: "Start Date",
                  },
                  dataField: "StartDate",
                  readonly: true,
                  editorOptions: {
                    allowUpdate:
                      this.dataModel.StatementType == "Outstanding"
                        ? false
                        : true,
                    onValueChanged: (e) => {
                      this.onStartDateChange(e);
                    },
                  },
                  required: true,
                  visible: this.dataModel.StatementType != "Outstanding",
                },
                {
                  screenField: "Date",
                  label: {
                    text: "End Date",
                  },
                  dataField: "EndDate",
                  editorOptions: {
                    min:
                      this.dataModel.StatementType != "Outstanding"
                        ? this.dataModel.StartDate
                        : undefined,
                    allowUpdate: true,
                  },
                  required: true,
                },
                {
                  // screenField: "Customer",
                  dataField: "CustomerName",
                  label: {
                    text: "Customer",
                  },
                  editorOptions: {
                    allowUpdate: false,
                  },
                },
                {
                  itemType: "group",
                  caption: "Aged by",
                  cssClass: "aged-by",
                  items: [
                    {
                      dataField: "Agedby",
                      label: {
                        text: "Aged by",
                        visible: false,
                      },
                      editorType: "dxRadioGroup",
                      editorOptions: {
                        layout: "horizontal",
                        items: [
                          {
                            value: "Month",
                          },
                          {
                            value: "Terms",
                          },
                        ],
                        valueExpr: "value",
                        displayExpr: "value",
                        // onValueChanged: () => {
                        //   this.saveFormPopupValueChange();
                        // },
                        // elementAttr: { class: "roam-despatch-radio-list" },
                      },
                    },
                  ],
                },
                // {
                //   screenField: "SequenceNo",
                //   dataField: "LotSequenceNo",
                // },
                // {
                //   screenField: "Variety",
                //   dataField: "ProductDescription",
                // },
                // {
                //   screenField: "Bins",
                //   label: "Bags / Pallet",
                //   dataField: "BagsPerPallet",
                // },
              ],
            },
          ],
        },
      ];
    },

    getVisible: {
      get() {
        return this.setVisible;
      },
      set() {
        return false;
      },
    },
  },
  watch: {},
  methods: {
    onStatementTypeChanged(e) {
      if (e.value == "Activity")
        this.dataModel.EndDate = this.dataModel.StartDate;
    },
    // eslint-disable-next-line no-unused-vars
    valueChangeCallBack(isValid, brokenRules) {
      // console.log("valueChangeCallBack ", isValid, brokenRules);
    },
    onStartDateChange(e) {
      if (this.dataModel.StartDate > this.dataModel.EndDate)
        this.dataModel.EndDate = e.value;
    },
    popupHidden() {
      if (this.hidden) this.hidden();
    },
    async onPreview() {
      const mainForm = await validationEngine.validateGroup(
        "gcPopupConfig-gc-popup-form-data",
      );

      if (mainForm.isValid)
        this.onItemClick({
          ScreenLayoutApplicationFeatureCode: "ReportCustomerStatementCX",
        });
      else {
        this.displayValidationSummary(mainForm.brokenRules);
      }
    },
    async onEmail() {
      const mainForm = await validationEngine.validateGroup(
        "gcPopupConfig-gc-popup-form-data",
      );

      if (!mainForm.isValid) {
        this.displayValidationSummary(mainForm.brokenRules);
        return;
      }

      var payload = {
        CustomerCode: this.dataModel.CustomerCode,
        StatementType: this.dataModel.StatementType,
        StartDate: this.dataModel.StartDate.toSaveDate(),
        EndDate: this.dataModel.EndDate.toSaveDate(),
        CreatedBy: UserService.getUsername(),
        AgeByPeriod: this.dataModel.Agedby == "Terms" ? false : true,
      };

      this.showLoading(true);
      await CustomerStatementService.reportBackgroundEmail(payload)
        .then((res) => {
          if (res) this.showLoading(false);
          this.$notify(`Email notification queued successfully`, "success");
          this.onCancel();
        })
        .catch((err) => {
          // if (err) this.showLoading(false);
          if (err) this.showLoading(false);
          this.$store.dispatch("ui/setServerError", {
            error: err,
            title: "Failed",
          });
        });
    },
    onCancel() {
      if (this.hidden) this.hidden();
    },

    async onItemClick(rowData) {
      this.showLoading(true);

      let data = { ...this.dataModel };
      data.Customer = this.dataModel.CustomerCode;
      data.StartDate = data.StartDate ? data.StartDate.toSaveDate() : undefined;
      data.EndDate = data.EndDate ? data.EndDate.toSaveDate() : undefined;

      if (rowData.ScreenLayoutApplicationFeatureCode) {
        var response;
        await TransactionReportService.getByFeatureCode(
          rowData.ScreenLayoutApplicationFeatureCode,
        )
          .then((res) => {
            response = res;
          })
          .catch((err) => {
            if (err) this.showLoading(false);
            this.validationItems = [];
            this.validationItems.push("Report repx not found");
            this.validationSummaryVisible = true;
            return;
          });

        var report = undefined;

        if (response && response.data) {
          report = response.data;
          report.Parameters = JSON.parse(response.data.Parameters);
          this.ExportToPdf(
            this.getQueryString(report.Parameters, data, report.Location),
          );
        } else this.showLoading(false);
      } else this.showLoading(false);
    },
    getQueryString(parameters, value, reportLocation) {
      let link = `/api/GetReportPdf?reportLocation=${reportLocation}`;
      // link += `&ReportRunDate=${this.dataModel.EndDate.toSaveDate()}&Customer=${
      //   this.dataModel.CustomerCode
      // }&AgeByPeriod=${this.dataModel.Agedby == "Terms" ? true : false}`;
      // return link;
      // this.showLoading(false);

      parameters.forEach((parameter) => {
        if (!parameter) return;
        var dataField = parameter.screenField;

        if (!value[dataField]) {
          let globalField = { ...getGlobalField(parameter.screenField) };
          if (globalField) {
            dataField = globalField.dataField;
          }
        }

        if (dataField == "AgeByPeriod")
          link += `&${dataField}=${
            this.dataModel.Agedby == "Month" ? true : false
          }`;
        if (dataField && value[dataField])
          link += `&${dataField}=${value[dataField]}`;
      });
      return link;
    },
    async ExportToPdf(url) {
      await ApiService.get(url)
        .then((res) => {
          const blob = b64toBlob(res.data, "application/pdf");
          const blobUrl = URL.createObjectURL(blob);
          this.showLoading(false);
          // this.onCancel();
          Object.assign(document.createElement("a"), {
            target: "_blank",
            href: blobUrl,
          }).click();
        })
        .catch((error) => {
          this.$logger.debug("ExportToPdf Error ", error);
          this.showLoading(false);
        });
    },
  },
};
</script>

<style lang="scss">
.aged-by {
  .dx-form-group-caption,
  .dx-item.dx-radiobutton .dx-item-content {
    font-size: 12px;
  }
}
</style>
